<template>
  <div class="details">
    <i class="el-icon-close" style="position: absolute;left: 3px; top: 5px; font-size: 25px; cursor: pointer;" @click="$emit('close')" />
    <div class="details_add">
      <div class="add_item">
        <span class="item_title">投放组</span>
        <span class="item_non">{{ drawerItem.release_group_name }}</span>
      </div>
      <div class="add_item">
        <span class="item_title">投手</span>
        <el-select v-model="addParameter.user_id" placeholder="请选择" filterable :disabled="isP" @clear="addParameter.user_id = null">
          <el-option
            v-for="item in tableData.user"
            :key="item.id"
            :label="item.nickname"
            :value="item.id"
          />
        </el-select>
      </div>
      <el-button type="primary" style="margin-left: 310px" @click="addPitcher">添加</el-button>
    </div>
    <div class="details_contentArea">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        max-height="300"
        border
        style="width: 80%; margin:0 auto;"
      >
        <el-table-column
          prop="id"
          label="投手id"
        />
        <el-table-column
          prop="user_name"
          label="用户名"
        />
        <!-- <el-table-column
          prop="feishu_account"
          label="飞书id"
        />
        <el-table-column
          prop="feishu_name"
          label="飞书人员"
        /> -->
        <el-table-column
          label="操作"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="deletePitcher(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="tableData.count"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

  </div>
</template>

<script>
import { release_group_user_add, listrelease_group_user, release_group_user_del } from '@/api/ListnewLaunchGroup.js'
// import { feishuuserlist } from '@/api/newLaunchGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  data() {
    return {
      tableData: {},
      isP: true,
      app_id: null,
      app_ids: null,
      pageinfo: {
        page: 1,
        pageSize: 10
      },
      parameter: {
        page: 1,
        pageSize: 10,
        group_id: this.drawerItem.id
      },
      addParameter: {
        group_id: this.drawerItem.id,
        user_id: null
      },
      current: false,
      loading: false
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {
    setTimeout(() => {
      this.isP = false
    })
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      try {
        const [data] = await Promise.all([
          listrelease_group_user(this.parameter)
        ])
        this.tableData = data.data
        this.loading = false
      } catch (error) {
        console.error('Error:', error)
      }
    },
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    // 添加投手
    async addPitcher() {
      let text = null
      this.addParameter.user_id || (text = '请选择投手')
      text || await release_group_user_add({ ...this.addParameter })
      text || this.getDataList()
      text || (this.addParameter.user_id = null, this.app_id = null, this.app_ids = null)
      this.$message({
        message: text || '添加投手成功',
        type: text ? 'warning' : 'success'
      })
    },

    // 删除投手
    async deletePitcher(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await release_group_user_del({ id: row.id })
        this.getDataList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },
    // async querySearchAsync(queryString, cb) {
    //   if (queryString === '') {
    //     this.app_id = null
    //     this.app_ids = null
    //   }
    //   const data = await feishuuserlist({ ...this.pageinfo, user_name: this.app_id })
    //   const newArr = data.data.map((item) => {
    //     return { ...item, value: item.name, address: item.openId }
    //   })
    //   cb(newArr)
    // },
    handleSelect(val) {
      this.app_ids = val.openId
      console.log(val)
    }
  }
}
</script>

<style scoped>
.details{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 100px;
}

.details_add{
    width: 80%;
    margin: 0 auto;
}

.add_item{
   margin-bottom: 15px;
}

.item_title{
    display: inline-block;
    width: 100px;
}

.item_non{

}

.details_contentArea{
  margin-top: 50px;
}
</style>
